
import AuthImage from '@/components/image/AuthImage.vue'
import JigTextField from '@/components/input/JigTextField.vue'
import JigTooltip from '@/components/input/JigTooltip.vue'
import LabelWithHint from '@/components/input/LabelWithHint.vue'
import MoreModelActions from '@/components/input/MoreModelActions.vue'
import LibraryCategoriesModal from '@/components/modals/LibraryCategoriesModal.vue'
import PromptYesNo from '@/components/modals/PromptYesNo.vue'
import UploadLibraryThumbnailDialog from '@/components/modals/UploadLibraryThumbnailDialog.vue'
import { TeamLibraryConst } from '@/constants/teamlibrary'
import FiltersMixin from '@/mixin/Filters'
import LibraryMixin from '@/mixin/Library'
import { LibraryObjectVisibility, LibraryVisibilities } from '@/modules/library/constants'
import helpers from '@/modules/library/helpers'
import { LibraryVisibility } from '@/modules/library/types'
import { Permissions } from '@/security/permissions'
import { PermissionActions } from '@/store/constants'
import { Tenant } from '@/store/modules/app/types'
import {
  LibraryCategoriesUsage,
  LibraryCategorySelectItem,
  LibraryEntry,
  LibraryItem,
  LibraryReferenceAsset,
} from '@/store/modules/teamlibrary/types'
import { Namespace, UploadThumbnailRequest } from '@/store/types'
import { CategoryHelpers } from '@/utils/category-helpers'
import { Filters } from '@/utils/filters'
import { ValidationRules } from '@/utils/input-validation'
import { TenantHelpers } from '@/utils/tenant-helpers'
import IconBin from '@svg/IconBin.svg'
import IconSpinner from '@svg/IconSpinner.svg'
import IconsUploadFile from '@svg/IconsUploadFile.svg'
import { mixins } from 'vue-class-component'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation, State } from 'vuex-class'

@Component({
  components: {
    AuthImage,
    IconBin,
    IconSpinner,
    IconsUploadFile,
    JigTextField,
    JigTooltip,
    LabelWithHint,
    LibraryCategoriesModal,
    MoreModelActions,
    PromptYesNo,
    UploadLibraryThumbnailDialog,
  },
})
export default class LibraryEntryVue extends mixins(FiltersMixin, LibraryMixin) {
  @State('libraryEntry', { namespace: Namespace.TeamLibrary })
  public libraryEntry!: LibraryEntry
  @State('libraryCategoriesUsage', { namespace: Namespace.TeamLibrary })
  public libraryCategoriesUsage!: LibraryCategoriesUsage
  @State('libraryReferenceAssets', { namespace: Namespace.TeamLibrary })
  public libraryReferenceAssets!: LibraryReferenceAsset[]
  @State('myTenantIndex', { namespace: Namespace.App }) public myTenantIndex!: number
  @State('myTenants', { namespace: Namespace.App }) public myTenants!: Tenant[]

  @Getter('libraryModelUID', { namespace: Namespace.TeamLibrary })
  public libraryModelUID!: number
  @Getter('isPreparingApp', { namespace: Namespace.Utils })
  public isPreparingApp!: boolean
  @Getter('libraryPublicCategoriesIDs', { namespace: Namespace.TeamLibrary })
  public libraryPublicCategoriesIDs!: number[]

  @Action('loadLibraryEntry', { namespace: Namespace.TeamLibrary })
  public loadLibraryEntry: any
  @Action('deleteLibraryEntryById', { namespace: Namespace.TeamLibrary })
  public deleteLibraryEntryById: any
  @Action('updateLibraryEntry', { namespace: Namespace.TeamLibrary })
  public updateLibraryEntry: any
  @Action('uploadLibraryEntryThumbnail', { namespace: Namespace.TeamLibrary })
  public uploadLibraryEntryThumbnail: any
  @Action('loadLibraryCategoryStates', { namespace: Namespace.TeamLibrary })
  public loadLibraryCategoryStates: any
  @Action('presignedFile', { namespace: Namespace.TeamLibrary })
  public presignedFile: any
  @Action('uploadReferenceFile', { namespace: Namespace.TeamLibrary })
  public uploadReferenceFile: any
  @Action('loadLibraryCategoriesUsage', { namespace: Namespace.TeamLibrary })
  public loadLibraryCategoriesUsage: any
  @Action('loadLibraryReferenceAssets', { namespace: Namespace.TeamLibrary })
  public loadLibraryReferenceAssets: any
  @Action('completeLibraryReferenceFileUpload', { namespace: Namespace.TeamLibrary })
  public completeLibraryReferenceFileUpload: any
  @Action('deleteLibraryReferenceAssetById', { namespace: Namespace.TeamLibrary })
  public deleteLibraryReferenceAssetById: any
  @Mutation('removeLibraryReferenceAssetByGuid', { namespace: Namespace.TeamLibrary })
  public removeLibraryReferenceAssetByGuid: any

  declare $refs: Vue['$refs'] & {
    deleteAssetPromptYesNo: PromptYesNo
    deleteEntryPromptYesNo: PromptYesNo
    publishEntryPromptYesNo: PromptYesNo
    refPDFFileInput: any
  }

  private isLoadingEntryData: boolean = false
  private visibilityPublic: string = LibraryObjectVisibility.Public
  private selectedEntry: any = { Id: '', DisplayName: '', Visibility: '' }
  private formIsValid: boolean = false
  private nameRules!: any
  private objectTagsRules!: any
  private urlRules!: any
  private uploadRules!: any

  private needPublishCheck: boolean = false
  private visibilityAlreadyPublic: boolean = false
  private readonly stateIdHidden = TeamLibraryConst.LibraryCategoriesStateId.Hidden
  private readonly stateIdDeprecated = TeamLibraryConst.LibraryCategoriesStateId.Deprecated
  private objectTags: string = ''
  private selectedCategory: number | null = null
  private referencePDFFile: File | null = null
  private refPDFFileName: string = ''
  private pdfFileSizeError: string = ''
  private readonly maxPDFFileSize = 50 * 1024 * 1024 // 50MB in bytes
  private referencePDFToDelete: LibraryReferenceAsset | null = null

  private showUploadModel: boolean = false
  private showCategoriesModel: boolean = false
  private isUploadingThumbnail: boolean = false
  private isSubmittingPDF: boolean = false
  private isCategoriesUsageLoading: boolean = false

  private isJigSpaceStaff: boolean = false
  private canEdit: boolean = false
  private canDelete: boolean = false

  private tagRules: any = {
    extra: [(v: any) => (v && !v.includes(',')) || 'Comma is not allowed'],
  }

  private readonlyMetadataBaseList: Partial<Record<keyof LibraryEntry, any>> = {
    Id: { label: 'Id', type: 'number' },
    UID: { label: 'UID', type: 'number' },
    Author: { label: 'Author', type: 'string' },
    DateCreated: { label: 'Created', type: 'datetime_string' },
    DateUpdated: { label: 'Last updated', type: 'datetime_string' },
    Version: { label: 'Version', type: 'number' },
  }
  private readonlyMetadataItemList: Partial<Record<keyof LibraryItem, any>> = {
    TriangleCount: { label: 'Triangles count', type: 'formated_number' },
    ObjectCount: { label: 'Sub-objects count', type: 'formated_number' },
    OriginalFileSizeInBytes: { label: 'Original size', type: 'filesize' },
    FileName: { label: 'Output file name', type: 'string' },
  }

  @Watch('initializing')
  private async onInitializingChanged(value: boolean, oldValue: boolean) {
    if (!value) {
      this.checkPermissions()
      await this.prepareEntryData()
    }
  }

  protected async created() {
    this.nameRules = ValidationRules.RequiredName
    this.objectTagsRules = ValidationRules.OptionalCommaSeparatedStrings
    this.urlRules = ValidationRules.OptionalUrl
    this.uploadRules = ValidationRules.PngImageUpload

    if (this.initializing) return

    this.checkPermissions()
    await this.prepareEntryData()
  }

  protected async mounted() {
    if (this.initializing) return
  }

  // Override the hook method
  protected onAfterTenantChanged(): void {
    this.checkPermissions()
  }

  private get hasReachedMaxReferencePDFs(): boolean {
    return this.libraryReferenceAssets.length >= TeamLibraryConst.LibraryEntryMaxReferencePDFs
  }

  private get maxReferenceFileMsg(): string {
    return `Maximum ${TeamLibraryConst.LibraryEntryMaxReferencePDFs} reference files allowed. Please delete existing files to add new ones.`
  }

  private get allowedReferenceFileType(): string {
    return TeamLibraryConst.LibraryModalAllowedReferenceType.join(',')
  }

  private get validLibraryCategories(): LibraryCategorySelectItem[] {
    return CategoryHelpers.buildCategorySelectItems({
      tenantCategories: this.libraryCategories,
      publicCategories: this.libraryPublicCategories,
      includePublic: this.isJigSpaceStaff,
      hiddenStateId: this.stateIdHidden,
      deprecatedStateId: this.stateIdDeprecated,
    })
  }

  private get libraryVisibilities(): LibraryVisibility[] {
    return LibraryVisibilities
  }

  private get dimensionInfo(): string {
    return `${TeamLibraryConst.ModelThumbnailDimension.width} x ${TeamLibraryConst.ModelThumbnailDimension.height}`
  }

  private get isPreparingDetails(): boolean {
    return this.isPreparingApp || this.isLoadingEntryData
  }

  private get isFormDisabled(): boolean {
    return this.isPreparingDetails || this.isSubmittingPDF
  }

  private get thumbnailSrc(): string {
    return this.libraryEntry.ThumbnailUrl || ''
  }

  private get metadataBaseList(): Partial<Record<keyof LibraryEntry, any>> {
    const fields: Partial<Record<keyof LibraryEntry, any>> = {}

    for (const metaKey in this.readonlyMetadataBaseList) {
      const typedKey = metaKey as keyof LibraryEntry
      const { label, type } = this.readonlyMetadataBaseList[typedKey]

      if (this.libraryEntry[typedKey] == null) {
        fields[typedKey] = {
          label,
          value: 'N/A',
        }
        continue
      }

      const fieldDetails: Record<string, any> = {
        label,
        value: this.libraryEntry[typedKey],
      }

      switch (type) {
        case 'number':
          fieldDetails.value = Number(this.libraryEntry[typedKey])
          if (isNaN(fieldDetails.value)) fieldDetails.value = 'N/A'
          break
        case 'datetime_string':
          fieldDetails.value = Filters.formatDate(this.libraryEntry[typedKey] as string)
          break
      }

      fields[typedKey] = fieldDetails
    }

    return fields
  }

  private get metadataItemList(): Partial<Record<keyof LibraryItem, any>> {
    const fields: Partial<Record<keyof LibraryItem, any>> = {}

    for (const metaKey in this.readonlyMetadataItemList) {
      const typedKey = metaKey as keyof LibraryItem
      const { label, type, key } = this.readonlyMetadataItemList[typedKey]

      if (this.libraryEntry.Item[typedKey] == null) {
        fields[typedKey] = {
          label,
          value: 'N/A',
        }
        continue
      }

      const fieldDetails: Record<string, any> = {
        label,
        value: this.libraryEntry.Item[typedKey],
      }

      switch (type) {
        case 'number':
          fieldDetails.value = Number(this.libraryEntry.Item[typedKey])
          if (isNaN(fieldDetails.value)) fieldDetails.value = 'N/A'
          break
        case 'formated_number':
          fieldDetails.value = Number(this.libraryEntry.Item[typedKey])
          if (isNaN(fieldDetails.value)) {
            fieldDetails.value = 'N/A'
          } else {
            fieldDetails.value = fieldDetails.value.toLocaleString('en-US')
          }
          break
        case 'array_length':
          fieldDetails.value = this.libraryEntry.Item[typedKey][key].length
          break
        case 'filesize':
          fieldDetails.value = helpers.formatFileSize(Number(this.libraryEntry.Item[typedKey]))
          break
      }

      fields[typedKey] = fieldDetails
    }

    return fields
  }

  private get hasSelectedPDF(): boolean {
    return this.referencePDFFile != null
  }

  private get toDeleteFileDetails(): string {
    return this.referencePDFToDelete ? `${this.referencePDFToDelete.originalFilename} (GUID: ${this.referencePDFToDelete.assetGuid})` : ''
  }

  private async prepareEntryData() {
    this.isLoadingEntryData = true
    const id = this.$route.params.id.toString()

    // Load tenant categories and optionally public categories (if JigSpace Staff)
    const promiseTenantCategories = this.loadLibraryCategories(this.myTenantID)
    const promisePublicCategories = this.isJigSpaceStaff ? this.loadLibraryCategories() : Promise.resolve(true)
    const promiseEntry = this.loadLibraryEntry({ Id: id })

    await this.loadLibraryCategoryStates()
    const results = await Promise.all([promiseTenantCategories, promisePublicCategories, promiseEntry])

    if (!results.every((result) => result)) {
      this.isLoadingEntryData = false
      return
    }

    await this.awaitLibraryEntryLoad(promiseEntry)
    this.isLoadingEntryData = false
  }

  private async deleteEntryById() {
    const deletionResult = await this.deleteLibraryEntryById(this.selectedEntry.Id)

    // Make sure to navigate away after deletion,
    // if any error happens user will remain on the same page and check error message.
    if (!deletionResult) return

    this.$router.push({ path: '/library' })
  }

  private async deleteAssetById() {
    if (this.referencePDFToDelete == null) return

    const deleteResult = await this.deleteLibraryReferenceAssetById(this.referencePDFToDelete.assetGuid)

    if (!deleteResult) return

    this.$refs.deleteAssetPromptYesNo.ClosePrompt()
    this.removeLibraryReferenceAssetByGuid(this.referencePDFToDelete.assetGuid)
    this.referencePDFToDelete = null
  }

  private async awaitLibraryEntryLoad(promiseLoadEntry: Promise<boolean>) {
    if (await promiseLoadEntry) {
      this.visibilityAlreadyPublic = this.libraryEntry.Visibility === LibraryObjectVisibility.Public

      this.selectedCategory = this.libraryEntry.Categories[0] != null ? this.libraryEntry.Categories[0] : null
      this.objectTags = this.libraryEntry.Tags.join(',')
    }

    if (this.libraryModelUID === -1) return

    await this.loadLibraryReferenceAssets({
      libraryModelId: this.libraryModelUID,
    })

    if (!this.libraryReferenceAssets || this.libraryReferenceAssets.length === 0) {
      this.referencePDFToDelete = null
      this.refPDFFileName = ''
    }
  }

  private showDeleteEntryPrompt(item: any) {
    this.selectedEntry = item
    this.$refs.deleteEntryPromptYesNo.ShowPrompt()
  }

  private async onPublishCheckSuccess() {
    this.needPublishCheck = false
    this.saveChanges()
  }

  private async saveChanges() {
    if (this.needPublishCheck) {
      this.selectedEntry = this.libraryEntry
      this.$refs.publishEntryPromptYesNo.ShowPrompt()
      return
    }

    // Prepare library entry updates
    this.libraryEntry.Tags = this.objectTags.split(',').map((tag: string) => tag.trim())
    this.libraryEntry.Categories = this.selectedCategory != null ? [this.selectedCategory] : []

    // Run PDF upload and entry update in parallel
    this.isSubmittingPDF = this.referencePDFFile !== null

    const hasPDF = !!this.referencePDFFile
    const promises: [Promise<boolean>, Promise<boolean>] | [Promise<boolean>] = hasPDF
      ? [this.uploadPDFFile(), this.updateLibraryEntry(this.libraryEntry)]
      : [this.updateLibraryEntry(this.libraryEntry)]

    const results = await Promise.all(promises)
    this.isSubmittingPDF = false

    // Extract results - Promise.all maintains input order, not completion order
    const pdfSuccess = hasPDF ? results[0] : true
    const updateSuccess = hasPDF ? results[1] : results[0]

    // Reload entry if both operations were successful
    if (updateSuccess && pdfSuccess) {
      const promiseLoadEntry = this.loadLibraryEntry({
        Id: this.libraryEntry.Id,
      })
      await this.awaitLibraryEntryLoad(promiseLoadEntry)
    }
  }

  private triggerPDFUploadField() {
    if (this.isSubmittingPDF) return

    this.$refs.refPDFFileInput.$el.querySelector('input').click()
  }

  private onPDFFileChange(file: File) {
    if (file && file.name) {
      // Validate file size (max 50MB)
      if (file.size > this.maxPDFFileSize) {
        this.pdfFileSizeError = 'File size must be 50MB or less'
        this.refPDFFileName = file.name
        this.referencePDFFile = null
        return
      }

      this.pdfFileSizeError = ''
      this.refPDFFileName = file.name
      this.referencePDFFile = file
    } else {
      this.clearReferencePDFSelection()
    }
  }

  private async uploadPDFFile(): Promise<boolean> {
    if (!this.referencePDFFile) return true

    const presignedResult = await this.presignedFile({
      libraryModelId: this.libraryModelUID,
      filename: this.referencePDFFile.name,
      mime: this.referencePDFFile.type,
      size: this.referencePDFFile.size,
    })

    if (!presignedResult) return false

    const uploadResult = await this.uploadReferenceFile({
      ...presignedResult,
      file: this.referencePDFFile,
    })

    if (!uploadResult || !uploadResult.data) return false

    const completeResult = await this.completeLibraryReferenceFileUpload({
      ...uploadResult.data,
      libraryModelId: this.libraryModelUID,
    })

    if (!completeResult) return false

    // Clear the file reference after successful upload
    this.clearReferencePDFSelection()

    return true
  }

  private removeReferencePDF() {
    this.clearReferencePDFSelection()
  }

  private removeReferenceAsset(asset: LibraryReferenceAsset) {
    this.referencePDFToDelete = asset
    this.$refs.deleteAssetPromptYesNo.ShowPrompt()
  }

  private clearReferencePDFSelection() {
    this.referencePDFFile = null
    this.refPDFFileName = ''
    this.pdfFileSizeError = ''
  }

  private checkAboutToPublish(option: LibraryObjectVisibility) {
    const isPublicSelected = option === LibraryObjectVisibility.Public

    if (!this.visibilityAlreadyPublic) {
      this.needPublishCheck = isPublicSelected
    } else {
      this.needPublishCheck = !isPublicSelected
    }

    if (isPublicSelected && this.selectedCategory != null && !this.libraryPublicCategoriesIDs.includes(this.selectedCategory)) {
      // If entry is switching to Public but selected category is not public, clear selection
      this.selectedCategory = null
    } else if (!isPublicSelected && this.selectedCategory != null && this.libraryPublicCategoriesIDs.includes(this.selectedCategory)) {
      // If entry is switching away from Public, and selected category is public, clear selection
      this.selectedCategory = null
    }
  }

  private async onThumbnailUpload(thumbnailFile: File) {
    const req: UploadThumbnailRequest = {
      Id: this.libraryEntry.Id.toString(),
      TenantId: this.myTenantID,
      Thumbnail: thumbnailFile,
      IsFirstThumbnail: this.libraryEntry.ThumbnailUrl.includes('placeholder'),
    }
    this.isUploadingThumbnail = true
    if (await this.uploadLibraryEntryThumbnail(req)) {
      const promiseLoadEntry = this.loadLibraryEntry({
        Id: this.libraryEntry.Id,
      })
      this.awaitLibraryEntryLoad(promiseLoadEntry)
    }
    this.isUploadingThumbnail = false
    this.showUploadModel = false
  }

  private checkPermissions() {
    this.canEdit = false
    this.canDelete = false
    this.isJigSpaceStaff = false
    const tenant = TenantHelpers.GetTenantByIndex(this.myTenantIndex, this.myTenants)
    if (tenant !== null && tenant !== undefined) {
      this.isJigSpaceStaff = TenantHelpers.IsTenantJigSpaceStaff(tenant)
      const tenantTokens = this.$auth0.tenants
      const tenantToken = TenantHelpers.GetTenantTokenByTenantID(tenantTokens, tenant.ID)
      if (tenantToken !== undefined) {
        this.canEdit = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Edit)
        this.canDelete = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Delete)
      }
    }
  }

  private onUploadClicked(payload: any) {
    this.showUploadModel = true
  }

  private onCancelUploadClick() {
    this.showUploadModel = false
  }

  private goBack() {
    if ((window && window.history.length > 1) || (history && history.length > 1)) {
      this.$router.back()
    } else {
      this.$router.push('/library')
    }
  }

  private async triggerManageCategoriesPrompt() {
    this.showCategoriesModel = true
    this.isCategoriesUsageLoading = true
    await this.loadLibraryCategoriesUsage(this.myTenantID)
    this.isCategoriesUsageLoading = false
  }

  private onCategoriesCancelClicked() {
    this.showCategoriesModel = false
    this.isCategoriesUsageLoading = false
  }

  private onCategoryChange(categoryId: number | null) {
    if (!this.isJigSpaceStaff || categoryId == null) return

    if (this.libraryPublicCategoriesIDs.includes(categoryId)) {
      this.libraryEntry.Visibility = LibraryObjectVisibility.Public
    } else {
      this.libraryEntry.Visibility = LibraryObjectVisibility.Tenant
    }

    this.checkAboutToPublish(this.libraryEntry.Visibility)
  }
}
